module.exports = __webpack_public_path__ + "img/Shahr.3dde8012.svg";